var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInvestment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1655281774129,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1660,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1012.8 630.4l-76.8-81.6c-12.8-12.8-33.6-17.6-46.4-8l-86.4 38.4c-20.8 8-30.4 33.6-20.8 56 8 20.8 33.6 30.4 56 20.8l17.6-8C798.4 796.8 664 896 510.4 896c-158.4 0-300.8-107.2-347.2-265.6-8-20.8-30.4-33.6-56-30.4-20.8 8-33.6 30.4-30.4 56 60.8 192 236.8 324.8 428.8 324.8S865.6 856 929.6 672l12.8 12.8c8 8 20.8 12.8 30.4 12.8 8 0 20.8-4.8 30.4-12.8 25.6-11.2 25.6-38.4 9.6-54.4zM115.2 505.6c8 0 12.8 0 20.8-4.8l89.6-51.2c20.8-12.8 30.4-38.4 17.6-60.8-12.8-20.8-38.4-30.4-60.8-17.6l-17.6 12.8c51.2-150.4 188.8-252.8 342.4-252.8 168 0 316.8 120 355.2 291.2 4.8 20.8 30.4 38.4 51.2 30.4 20.8-4.8 38.4-30.4 30.4-51.2C905.6 192 720 43.2 515.2 43.2 316.8 43.2 145.6 176 86.4 368l-12.8-12.8c-17.6-17.6-43.2-17.6-60.8 0-17.6 17.6-17.6 43.2 0 60.8l76.8 81.6c0 3.2 12.8 8 25.6 8z",
    "p-id": 1661
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M699.2 625.6c17.6-81.6-46.4-153.6-128-153.6h-115.2c-25.6 0-43.2-17.6-43.2-43.2s20.8-43.2 43.2-43.2H640c25.6 0 43.2-17.6 43.2-43.2s-17.6-43.2-43.2-43.2h-86.4V256c0-20.8-17.6-43.2-43.2-43.2s-43.2 17.6-43.2 43.2v43.2h-8c-64 0-124.8 43.2-132.8 102.4-17.6 81.6 46.4 153.6 128 153.6h115.2c25.6 0 43.2 17.6 43.2 43.2s-20.8 43.2-43.2 43.2H382.4c-25.6 0-43.2 17.6-43.2 43.2s17.6 43.2 43.2 43.2h86.4v43.2c0 20.8 17.6 43.2 43.2 43.2s43.2-17.6 43.2-43.2v-43.2h12.8c62.4 0 123.2-41.6 131.2-102.4z",
    "p-id": 1662
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.d58d2fc8.svg";
export { ForwardRef as ReactComponent };